export default function OpenSearchBar() {
  const searchBtns = document.querySelectorAll('.search-btn');
  const searchBar = document.querySelector('#header__search-bar');

  if (!searchBtns.length || !searchBar) return;

  searchBar.style.display = 'none';

  searchBtns.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();

      const isHidden = searchBar.style.display === 'none';

      searchBar.style.display = isHidden ? 'block' : 'none';
      searchBar.classList.toggle('active', isHidden);
    });
  });

  document.addEventListener('click', function (e) {
    const clickedInsideButton = [...searchBtns].some(btn =>
        btn.contains(e.target)
    );

    if (!searchBar.contains(e.target) && !clickedInsideButton) {
      searchBar.classList.remove('active');
      searchBar.style.display = 'none';
    }
  });
}